import { render } from "./SelectBook.vue?vue&type=template&id=ed8d3730"
import script from "./SelectBook.vue?vue&type=script&lang=js"
export * from "./SelectBook.vue?vue&type=script&lang=js"
script.render = render

export default script